import React, { useEffect, useState } from "react";
import { updatePhoneNo } from "../../../../Utils/SupabaseServices/UserDatabase";
import { supabase } from "../../../../config/supabaseClient";
import { Button, Modal, Radio, RadioChangeEvent, Spin } from "antd";
import HelperText from "../../../../components/HelperText/HelperText";
import { useAuth } from "../../../../hooks/useAuth";

const Phone = (props: any) => {
  const { user_id, username, userData, setIsPhone } = props;
  const { isMember, session, isAdmin } = useAuth();
  // Get the phone from appropriate source based on user type
  const getInitialPhone = () => {
    if (!isAdmin && isMember && session?.user?.email !== userData?.email) {
      // For members, try to get phone from their auth metadata or user data
      return userData?.team_members?.find((member: any) => member?.email === session?.user?.email)?.phoneNumber || "";
    }
    return userData?.phoneNo || "";
  };

  const [phone, setPhone] = useState(getInitialPhone());
  const [originalPhone, setOriginalPhone] = useState(getInitialPhone());
  const [editPhone, setEditPhone] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const [phoneCode, setPhoneCode] = useState<any>(userData.phone_code || "");
  const [initialPhoneNumber, setInitialPhoneNumber] = useState(phone); // Store the original phone number

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalError, setModalError] = useState("");
  const [modalContent, setModalContent] = useState(false);
  const [isPhoneVerify, setIsPhoneVerify] = useState<any>();
  const [isTabsLocked, setIsTabsLocked] = useState<any>();
  const [isPhoneChanged, setIsPhoneChanged] = useState(false);
  const [value, setValue] = useState(1);
  const [initialValue, setInitialValue] = useState(1); // Add this line to track initial value

  // Update phone when user type or session changes
  useEffect(() => {
    const newPhone = getInitialPhone();
    setPhone(newPhone);
    setOriginalPhone(newPhone);
  }, [isMember, session, userData]);

  useEffect(() => {
    const handleStorageChange = () => {
      const data = localStorage.getItem("phone_verify");
      if (data === "false") {
        setIsTabsLocked(true);
      } else {
        setIsTabsLocked(false);
      }
     
    };

    // Add event listener for storage changes
    window.addEventListener("storage", handleStorageChange);

    // Initial setup (run once)
    handleStorageChange();

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [window]);
  // useEffect(()=>{
  //   if(phoneNumber.startsWith("91")){
  //     setValue(91)
  //     setInitialValue(91) // Set initial value here
  //   }else{
  //     setValue(1)
  //     setInitialValue(1) // Set initial value here
  //   }
  // },[phoneNumber])
  const onChange = (e: RadioChangeEvent) => {
    setPhoneCode(e.target.value);
    setValue(e.target.value);
  };
  const [otp, setOTP] = useState("");

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  function handleUpdateValue(e: any, option: any) {
    if (option === "phone") {
      // Only allow numeric input
      const numericValue = e.target.value.replace(/[^0-9]/g, '');
      
      // Allow empty value or validate 10 digits
      setPhone(numericValue);
      if (numericValue === "") {
        setPhoneError("");
      } else if (numericValue.length !== 10) {
        setPhoneError("Phone number must be 10 digits");
      } else {
        setPhoneError("");
      }
    }
  }
  const doneEdit = async (option: any) => {
    if (option === "phone") {
      setIsPhoneChanged(true);
      // Allow empty phone number or validate 10 digits
      if (phone !== "" && phone.length !== 10) {
        setPhoneError("Phone number must be 10 digits");
        return;
      }
      
      // Determine which user to update based on login type
      const isMemberPhone = isMember && session?.user?.email !== userData?.email;
      const targetUserId = isMemberPhone ? session?.user?.user_metadata?.creator_id : user_id;
      const targetUsername = isMemberPhone ? session?.user?.email : username;
      
      const { data, error } = await updatePhoneNo(targetUserId, targetUsername, phone, isMemberPhone!);
      if (!error) {
        setEditPhone(false);
        setIsPhone(true);
        if (props.userData && !isMember) {
          props.userData.phoneNo = phone;
        }
        props.refetch();
        setOriginalPhone(phone);
      } else {
        setPhoneError(error instanceof Error ? error.message : "Failed to update phone number");
      }
      setInterval(() => {
        setIsPhoneChanged(false);
      }, 1000);
    }
  };
  
  async function sendPhoneNumberOTP() {
    setOTP("");
    setModalError("");
    setIsModalOpen(true);
    setModalContent(true);
    setModalTitle("Verify Phone Number");
    let phNumber = `${value}${phone}`;
    const { data, error } = await supabase.auth.signInWithOtp({
      phone: phNumber,
    });
    if (error !== null) {
      setModalError("Error in sending OTP. Try again after 60 seconds");
    }
  }

  async function verifyPhoneNumber() {
    let phNumber = `${value}${phone}`;

    await supabase.auth
      .verifyOtp({
        phone: phNumber,
        token: otp,
        type: "sms",
      })
      .then((res: any) => {
        if (res.error === null) {
          setIsModalOpen(false);
          setIsPhone(true);
          setIsPhoneVerify(true);
          localStorage.removeItem("phone_verify");
        } else {
          setModalError("Invalid OTP");
        }
      });
  }
  const cancelEdit = () => {
    setPhone(originalPhone);
    setEditPhone(false);
    
   setValue(phoneCode)
    // setValue(initialValue); // Reset the radio selection to initial value
  };
  return (
    <div className="account-tile">
      <div className="account-tile-header">
        <div className="account-tile-title">
          <p>Phone</p>
          <HelperText message="This is the phone number connected to your account." />
        </div>
      </div>
      <div className="account-tile-value">
        {!editPhone ? (
          <div style={{ alignItems: 'center', gap: "10px" }}>
            <div style={{ margin: '0.25rem 0 0.5rem' }}>{isPhoneChanged ? <Spin /> : phone || "Add phone number"}</div>
            <Button
              className="accountButton"
              onClick={() => {
                setEditPhone(true);
                setOriginalPhone(phone);
              }}
              style={{
                width: '100%',
                padding: '0.5rem 1rem'
              }}
            >
              Change
            </Button>
          </div>
        ) : (
          <div>
            <input
              type="tel"
              style={{ 
                width: '100%', 
                padding: '0.5rem', 
                borderRadius: '6px', 
                border: '1px solid #e5e7eb',
                marginBottom: '0.75rem'
              }}
              onChange={(e: any) => handleUpdateValue(e, "phone")}
              value={phone}
              placeholder="Enter 10 digit number"
              maxLength={10}
            />
            <div className="account-button-group">
              <Button
                className="accountButton"
                onClick={() => {
                  doneEdit("phone");
                }}
                disabled={phone !== "" && phone.length !== 10}
              >
                Save
              </Button>
              <Button
                className="cancelButton"
                onClick={() => {
                  setEditPhone(false);
                  setPhone(originalPhone);
                  setPhoneError("");
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        )}
      </div>
      {phoneError && <p style={{ color: '#ef4444', fontSize: '0.875rem', marginTop: '0.5rem' }}>{phoneError}</p>}
      <Modal
        title={modalTitle}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="account-modal"
        footer={null}
      // footer={modalTitle==="Verify Phone Number"?null:ok}
      >
        {modalContent === true ? (
          <>
            <input
              type="text"
              className="otp-input"
              placeholder="Enter 6 digit OTP"
              onChange={(e: any) => setOTP(e.target.value)}
              value={otp}
            />
            <button className="modal-verify-btn" onClick={verifyPhoneNumber}>
              Verify
            </button>
          </>
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
};

export default Phone;
